export default {
  setSchedules(state, schedules) {
    state.schedules = Array.isArray(schedules) ? schedules : [];
  },

  setTasks(state, tasks) {
    state.tasks = Array.isArray(tasks) ? tasks : [];
  },

  replaceSchedule(state, { id, schedule }) {
    const index = state.schedules.findIndex(item => (item.id ?? item.taskScheduleId) === id);

    if (index !== -1) {
      state.schedules.splice(index, 1, schedule);
    }
  }
};
